import request from '@/libs/request'

// 猪场仔猪转舍 列表
export function pigChildTransferListApi (data) {
  return request({
    url: `pigFarm/pigChildTransfer`,
    method: 'get',
    params: data
  })
}

// 猪场仔猪转舍 详情
export function pigChildTransferDetailApi (id) {
  return request({
    url: `pigFarm/pigChildTransfer/` + id,
    method: 'get'
  })
}

// 猪场仔猪转舍 编辑/添加
export function pigChildTransferSaveApi (data) {
  return request({
    url: `pigFarm/pigChildTransfer`,
    method: 'post',
    data: data
  })
}

// 猪场仔猪转舍 删除
export function pigChildTransferDelApi (id) {
  return request({
    url: `pigFarm/pigChildTransfer/` + id,
    method: 'delete'
  })
}

